// extracted by mini-css-extract-plugin
module.exports = {"triggerWrapper":"styles_triggerWrapper__bwU7z","directSalesContent":"styles_directSalesContent__TChpO","list":"styles_list__D5NJA"};